import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import type { useAuthDataStore } from '@/stores/auth-data';

type AuthStore = ReturnType<typeof useAuthDataStore>;

/**
 * Where an admin-only route should send this user, or null to allow it.
 *
 * Abstains until `initialized` is true, matching the authentication check it runs after:
 * on a cold load the route resolves before Firebase has answered. AdminDashboardView's own
 * render gate covers that window.
 */
export function adminRedirect(to: RouteLocationNormalized, auth: AuthStore): RouteLocationRaw | null {
    if (!to.meta?.admin) return null;
    if (!auth.initialized) return null;
    if (auth.isAdministrator) return null;

    return { name: 'home' };
}
